(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGOBridge"), require("FEGOWebapi"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGOBridge", "FEGOWebapi"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/flow-scroll-quotes/render"] = factory(require("VueDemi"), require("FEGOBridge"), require("FEGOWebapi"));
	else
		root["/fego/component/flow-scroll-quotes/render"] = factory(root["VueDemi"], root["FEGOBridge"], root["FEGOWebapi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__2309__, __WEBPACK_EXTERNAL_MODULE__7145__, __WEBPACK_EXTERNAL_MODULE__5113__) => {
return 